import PropTypes from "prop-types"
import React from "react"

const PrintIdentGrid = ({ cells }) => (
  <div className="grid grid-cols-3 gap-x-7 gap-y-3.5 border-b border-gray-300 py-5">
    {cells.map(({ label, value }) => (
      <div key={label}>
        <div className="text-xxs font-bold uppercase tracking-wide">
          {label}
        </div>
        <div className="mt-0.5 text-sm font-semibold">{value || "—"}</div>
      </div>
    ))}
  </div>
)

PrintIdentGrid.propTypes = {
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    })
  ).isRequired,
}

export default PrintIdentGrid
